import NZBankDeposit from '../components/incoming-pages/NZ-BankDeposit.vue'
import NZPOLi from '../components/incoming-pages/NZ-POLi.vue'
import IRBankDeposit from '../components/incoming-pages/IR-BankDeposit.vue'
import TRBankDeposit from '../components/incoming-pages/TR-BankDeposit.vue'
import OMBankTransfer from '../components/incoming-pages/OM-BankTransfer.vue'
import TXUSDTDeposit from '../components/incoming-pages/TX-USDTDeposit.vue'
import IDBankTransfer from "../components/incoming-pages/ID-BankTransfer.vue"
import AUFinmoMethod1 from "../components/incoming-pages/AU-FinmoMethod1.vue"
import AUPayID from "../components/incoming-pages/AU-PayID.vue"
import NeoBanks from "../components/incoming-pages/NeoBanks.vue"

export const IncomingPaymentMethodPagesMixin = {
    data: () => ({
        incoming_payment_method_page_templates: [
            {name: 'AU-PayID'},
            {name: 'NZ-POLi'},
            {name: 'AU-FinmoMethod1'},
            {name: 'NZ-BankDeposit'},
            {name: 'ID-BankTransfer'},
            {name: 'IR-BankDeposit'},
            {name: 'TR-BankDeposit'},
            {name: 'TX-USDTDeposit'},
            {name: 'OM-BankTransfer'},
            {name: 'NeoBanks'},
        ]
    }),
    components: {
        'NZ-POLi': NZPOLi,
        'AU-PayID': AUPayID,
        'NeoBanks' : NeoBanks,
        'AU-FinmoMethod1': AUFinmoMethod1,
        'NZ-BankDeposit': NZBankDeposit,
        'IR-BankDeposit': IRBankDeposit,
        'TR-BankDeposit': TRBankDeposit,
        'TX-USDTDeposit': TXUSDTDeposit,
        'IDBankTransfer': IDBankTransfer,
        'OM-BankTransfer': OMBankTransfer
    }
}
